@if (loading) {
  <pr-loader></pr-loader>
}
<ng-container>
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
    <form-wrapper>
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="signature-type-selector">
            <label class="signature-label">Type de signature :</label>
            <div class="signature-toggle">
              <button
                type="button"
                class="signature-option"
                [class.active]="signatureType === 'PAPER'"
                (click)="onSignatureTypeChange('PAPER')"
              >
                <pr-icon name="description" class="signature-icon"></pr-icon>
                Signature papier
              </button>
              <button
                type="button"
                class="signature-option"
                [class.active]="signatureType === 'ELECTRONIC'"
                (click)="onSignatureTypeChange('ELECTRONIC')"
              >
                <pr-icon name="fingerprint" class="signature-icon"></pr-icon>
                Signature électronique
              </button>
            </div>
          </div>
        </div>
      </div>
      @if (isV2) {
        <!-- Séquençage V2 — Pas de récapitulatif des documents ici : déjà vus aux étapes
             précédentes (PackBuilder pour édition + document-compliance pour preview PDF).
             L'utilisateur choisit juste le type de signature et envoie. -->
      } @else {
        <ng-container formArrayName="documentsForm">
          @for (doc of documentsForm.controls; track doc; let index = $index) {
            @if (signatureType === 'ELECTRONIC') {
              <div class="doc-container">
                @if (index == 0) {
                  <div class="row">
                    <div class="col col-md-3 text-align-end"></div>
                    <div class="col col-md-9 d-flex padding-left-6">
                      @if (!hasDanger(verificationResults)) {
                        <pr-icon name="fingerprint" class="info__icon"></pr-icon>
                      }
                      <span class="file">
                        <img src="assets/svg/ressources/file.svg" />
                      </span>
                      <pr-icon name="visibility_off" class="info__icon"></pr-icon>
                    </div>
                  </div>
                }
                <div class="row d-flex align-items-center">
                  <div class="col col-md-3 text-align-end">
                    <span>{{ doc.get('name')?.value }}</span>
                  </div>
                  <div class="col col-md-9">
                    <ng-container [formGroup]="doc">
                      <pr-checkbox-group
                        formControlName="check"
                        [options]="
                          hasDanger(verificationResults)
                            ? [
                                { label: '', value: 'doc' },
                                { label: '', value: 'empty' },
                              ]
                            : [
                                {
                                  label: '',
                                  value: 'print',
                                  disabled:
                                    doc.get('check')?.status === 'DISABLED'
                                      ? true
                                      : false,
                                },
                                { label: '', value: 'doc' },
                                { label: '', value: 'empty' },
                              ]
                        "
                        [asToggle]="true"
                      >
                      </pr-checkbox-group>
                    </ng-container>
                  </div>
                </div>
              </div>
            }
          }
        </ng-container>
      }
      @if (certif && signatureType === 'ELECTRONIC') {
        <div class="row mt">
          <div class="col-md-12">
            <pr-color-panel [display]="verificationResults?.display">
              <pr-panel-body clazz="pam">
                <pr-label
                  [name]="verificationResults?.icon"
                  [width]="18"
                  [height]="18"
                  >{{ verificationResults?.text }}</pr-label
                >
              </pr-panel-body>
            </pr-color-panel>
          </div>
        </div>
      }
    </form-wrapper>
    <form-footer
      (prev)="prev()"
      (next)="onSubmit()"
      [nextLabel]="'Envoyer'"
      [disabledSkip]="true"
    ></form-footer>
  </form>
</ng-container>

<pr-modal-confirm
  display="warning"
  title="Confirmation"
  labelConfirm="Confirmer"
  labelCancel="Retour"
  (onConfirm)="onConfirmSubmit()"
>
  <p [innerHTML]="modalMessage"></p>
</pr-modal-confirm>

<ng-template #loadingTem>
  <pr-loader text="Génération des documents..."></pr-loader>
</ng-template>
@if (loading) {
  <pr-loader text="Génération des documents..."></pr-loader>
}
